import React, {FunctionComponent} from 'react';
import {Rectangle} from 'pixi.js';
import {_ReactPixi} from '@inlet/react-pixi';
import {ButtonCustom, ButtonCustomIdle, ButtonCustomPressed, CoreSprite} from '@gongxigames/framework/core/fragments/react';

export type DotButtonProps = Omit<_ReactPixi.IContainer, 'position'> & {
    press: null | (() => void);
    active?: boolean;
    position?: [x: number, y: number];
};

const DOT_SIZE = 94;
const DOT_HALF_SIZE = DOT_SIZE / 2;

export const DotButton: FunctionComponent<DotButtonProps> = (props) => {
    const {position = [0, 0]} = props;

    const x = position[0] - DOT_HALF_SIZE;
    const y = position[1] - DOT_HALF_SIZE;

    const hitArea = new Rectangle(0, 0, DOT_SIZE, DOT_SIZE);

    return (
        <ButtonCustom {...props} hitArea={hitArea} position={[x, y]}>
            <ButtonCustomIdle>
                <CoreSprite src='preloader_dot_normal'/>
            </ButtonCustomIdle>
            <ButtonCustomPressed>
                <CoreSprite src='preloader_dot_disabled'/>
            </ButtonCustomPressed>
        </ButtonCustom>
    );
};
